const PreparationStationSkeleton = () => {
  return (
    <div className="grid grid-cols-1 gap-4 p-5 lg:grid-cols-2 xl:grid-cols-3">
      {[1, 2, 3].map((item) => (
        <div
          key={item}
          className="h-56 animate-pulse rounded-xl bg-gray-2 dark:bg-meta-4"
        />
      ))}
    </div>
  );
};

export default PreparationStationSkeleton;
